const defaultRender = (value) => (value ? value : "--");

const blogColumns = [
  {
    title: "Image URL",
    dataIndex: "image",
    render: defaultRender,
  },
  {
    title: "Title",
    dataIndex: "title",
    render: defaultRender,
  },
  {
    title: "Description",
    dataIndex: "desc",
    render: defaultRender,
  },
  {
    title: "Date",
    dataIndex: "date",
    render: defaultRender,
  },
  {
    title: "Created at",
    dataIndex: "created_at",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
  },
];

export default blogColumns;
